// src/components/ScrollingTicker.js
import React, { useContext, useState, useEffect } from "react";
import { LanguageContext } from "../context/LanguageContext";
import { useNavigate } from "react-router-dom";

const TEXT = {
  EN: [
    "Italian Luxury Footwear",
    "New Heels & Boots Weekly",
    "Handmade in Italy",
    "Premium Leather Craftsmanship",
    "Delivery Across Lebanon",
  ],
  AR: [
    "أحذية إيطالية فاخرة",
    "موديلات جديدة أسبوعياً",
    "مصنوعة يدويًا في إيطاليا",
    "جودة وجلد فاخر",
    "توصيل الى كافة الاراضي اللبنانية",
  ],
};

// =============== ENGLISH TICKER ===============
function EnglishTicker({ items }) {
  return (
    <div className="ticker-container-en group">
      <div className="ticker-move-en">
        <div className="ticker-track-en">
          {items.map((text, i) => (
            <React.Fragment key={i}>
              <span className="ticker-item">{text}</span>
              {i !== items.length - 1 && (
                <span className="ticker-divider">•</span>
              )}
            </React.Fragment>
          ))}
        </div>

        {/* Duplicate for seamless scrolling */}
        <div className="ticker-track-en">
          {items.map((text, i) => (
            <React.Fragment key={"dup" + i}>
              <span className="ticker-item">{text}</span>
              {i !== items.length - 1 && (
                <span className="ticker-divider">•</span>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}

// =============== ARABIC TICKER ===============
function ArabicTicker({ items }) {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused) return;

    const id = setInterval(() => {
      setIndex((p) => (p + 1) % items.length);
    }, 3000);

    return () => clearInterval(id);
  }, [paused, items.length]);

  return (
    <div
      className="ticker-container-ar"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <div key={index} className="ticker-ar-item">
        <span className="ticker-item" dir="rtl">
          {items[index]}
        </span>
      </div>
    </div>
  );
}

function ScrollingTicker() {
  const { lang } = useContext(LanguageContext);
  const navigate = useNavigate();
  const items = TEXT[lang];

  return (
    <div
      className="w-full bg-[#F8F4F2] border-y border-[#E4D7D0] py-3 mb-6 cursor-pointer active:scale-[0.99] transition"
      onClick={() => navigate("/all-products")}
      title={lang === "EN" ? "Explore All Products" : "تصفّح كل المنتجات"}
    >
      {lang === "EN" ? (
        <EnglishTicker items={items} />
      ) : (
        <ArabicTicker items={items} />
      )}
    </div>
  );
}

export default ScrollingTicker;
